import { DndPreview } from '@hendrx/core/common/components/dnd/DndPreview';
import { widgetManifests } from '@hendrx/core/common/contentObjects';
import { PBLToolbox } from '@hendrx/core/pbl/components/PBLToolbox';
import { EditPBLPage } from '@hendrx/core/pbl/pages/EditPBLPage';
import { Plugins } from '@hendrx/core/plugins/components/Plugins';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/pbl/edit/$pblDraftId')({
  component: StudioPBLEditPage
});

function StudioPBLEditPage() {
  const toolbox = <PBLToolbox widgetManifests={widgetManifests} pluginsContent={<Plugins category="embed" />} />;

  const { pblDraftId } = Route.useParams();

  return (
    <>
      <DndPreview />
      <EditPBLPage pblDraftId={pblDraftId} toolbox={toolbox} />
    </>
  );
}
